<div>
  <div class="messages-header">
    <span class="messages-title text-white">Messages</span>
    <span class="messages-icon text-white" title="draw geofence and send message" (click)="startDrawing()">
      <i class="fa-solid fa-map-location-dot"></i>
    </span>
  </div>

  <!-- Tabs -->
  <ul class="nav p-1 m-1 nav-tabs custom-tabs">
    <li [class.active]="showIncoming">
      <a   (click)="setShowIncoming()">
        New ({{ data.totalNewMessages }})
      </a>
    </li>
    <li [class.active]="showArchived">
      <a (click)="setShowArchived()">
        Read ({{ data.totalReadMessages }})
      </a>
    </li>
    <li [class.active]="showSent">
      <a (click)="setShowSent()">
        Sent ({{ data.totalSentMessages }})
      </a>
    </li>
  </ul>

  <!-- Page Dropdown -->
  @if (pageDropDownMenu.length > 0 && ((showSent && data.sentMessages.length > 0) || (showArchived && data.readMessages.length > 0) || (showIncoming && data.newMessages.length > 0))) {
    <div
      class="mt-2 mb-2">
      <select class="form-select w-auto d-inline-block" [(ngModel)]="selectedPage" (change)="onPageChange()">
        @for (page of pageDropDownMenu; track page) {
          <option [ngValue]="page"
          [selected]="selectedPage?.page === page.page">{{ page.display }}</option>
        }
      </select>
    </div>
  }

  <!-- Incoming (New) -->
  @if (showIncoming) {
    <div class="tab-content custom-scroll">
      <table class="table table-hover custom-table">
        <tbody>
          @for (item of data.newMessages; track item) {
            <tr style="cursor: pointer">
              <td>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between border-bottom">
                      <span>From: {{ item.fromName || item.from }}</span>
                      <span class="small">{{ item.localTime }}</span>
                    </div>
                    <div>
                      <span class="text-muted small">{{ item.methodsStr }}</span>
                      <span class="ms-2">{{ item.subjectStr }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Archived (Read) -->
  @if (showArchived) {
    <div class="tab-content custom-scroll">
      <table class="table table-hover custom-table">
        <tbody>
          @for (item of data.readMessages; track item) {
            <tr style="cursor: pointer" (click)="openMessageDetail(item, false)">
              <td>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between border-bottom">
                      <span>From: {{ item.from }}</span>
                      <span class="small">{{ item.localTime }}</span>
                    </div>
                    <div>
                      <span class="text-muted small">{{ item.methodsStr }}</span>
                      <span class="ms-2">{{ item.subjectStr }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Sent -->
  @if (showSent) {
    <div class="tab-content custom-scroll">
      <table class="table table-hover custom-table">
        <tbody>
          @for (item of data.sentMessages; track item) {
            <tr style="cursor: pointer"  (click)="openMessageDetail(item, true)">
              <td>
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between border-bottom">
                      <span>To: {{ item.to }}({{item.recipientCount}})</span>
                      <span class="small">{{ item.localTime }}</span>
                    </div>
                    <div>
                      <span class="text-muted small">{{ item.methodsStr }}</span>
                      <span class="ms-2">{{ item.subjectStr }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

</div>